
<!-- Template -->
<template>
   <div class="col-sm-12 col-lg-12" style="margin-top:5em">
                        <div class="sidebar">
                            <div class="col-md-4 widget">
                                <h2 class="widgettitle">Trending Forums</h2>
                                <div>
                                    <ul class="list-group"  v-for="(forum, index) in forums" :key="index">
                                        <a style="cursor:pointer" @click="setForum(forum.forum_id)"  v-show="(index) < 6">
                                            <li class="list-group-item">
                                                <span class="badge" style="background-color: #22baae;">{{forum.forum_comments.length}}</span>
                                                <p style="color: #333;">{{forum.forum_topic}}</p>
                                            </li>
                                        </a>
                                        
                                    </ul>
                                </div>
                            </div><!-- /.widget -->

                            <div class="col-md-4 widget" v-if="pageNotSurvey">
                                <h2 class="widgettitle">Trending Live Poll</h2>
                                <div v-for="(survey, index) in surveys" :key="index">
                                    <router-link to="/cnsurveys">
                                    <div class="panel panel-poll" v-show="(index) < 1">
                                        <div class="panel-heading">
                                            <b>{{survey.cnsurvey_title}}</b>
                                        </div>
                                        <div class="panel-body">
                                            <div v-for="(svq, index2) in survey.cnsurveys_questions" v-show="index2 === survey.cnsurvey_question_index" :key="index2">
                                             <p><b>{{svq.cnsurvey_question}}</b></p>
                                             <div class="options" v-for="(opt,index22) in svq.cnsurveys_option" :key="index22">
                                                 
                                                 <div>
                                                     <div class="radio">
                                                         <input id="op" type="radio" :value="opt.cnsurvey_option_id"><label>{{opt.cnsurvey_option_option}}</label>
                                                     </div>
                                                 </div>
                                                
                                             </div>
                                             <button class="btn btn-xs btn-default pull-right" @click="next(index,index2)">Next</button>
                                           
                                             <div style="margin-top:1em;"><br><br><p style="font-size:11px" v-if="survey.cnsurvey_business != 0">Survey by: {{survey.cnsurvey_business_name}}</p></div>
                                            
                                            </div>
                                         </div>
                                    </div>
                                    </router-link>
                                </div>
                            </div><!-- /.widget -->
                            <div class="col-md-4 widget hidden-xs">
                                    <h2 class="widgettitle">Search Listings</h2>
    
                                    <div class="detail-enquire-form background-white p20">
                                        <form>
                                            <div class="form-group">
                                                <select v-model="search.parent" @change="prep_sub_categories(search.parent)" class="search-select form-control" title="Location">
                                                    <option :value="undefined">What do you want to find today?</option>    
                                                    <option v-for="cc in cnproParentCategories" :value="cc.cnpro_parent_category_id" :key="cc.cnpro_parent_category_id">{{cc.cnpro_parent_category_name}}</option>
                                                    <option value="business-search">Businesses</option>
                                                </select>
                                            </div><!-- /.form-group -->
    
                                           <div class="form-group">
                                                 <select v-if="search.type != 'business-search'" v-model="search.area" @change="prep_search(search.area)" class="search-select form-control" title="Location">
                                                    <option :value="undefined">Which of these services in particular</option>
                                                    <option v-for="cc in sub_categories" :value="cc.cnpro_category_name" :key="cc.cnpro_category_name">{{cc.cnpro_category_name}}</option>
                                                </select>
                                                <select v-else v-model="search.area" @change="prep_search(search.area)" class="search-select form-control" title="Location">
                                                    <option :value="undefined">Which of these services in particular</option>
                                                    <option v-for="cc in sub_categories" :value="cc.business_category_name" :key="cc.business_category_name">{{cc.business_category_name}}</option>
                                                </select>
                                            </div><!-- /.form-group -->
    
                                            
    
                                            <button class="btn btn-primary btn-block" type="submit" @click="doSearch">
                                                <i class="fa fa-search"></i> Search
                                            </button>
                                        </form>
                                    </div>
                                </div>

                          
                            <!-- /.widget -->
                        </div><!-- /.sidebar -->
                    </div><!-- /.col-* -->

      
</template>

<!-- Script -->
<script>
import services from './../services/service'; // Service Class
let service = new services();

export default {
    name: "Sidebar",
    data() {
        return {
            forums: {},
            forum: {},
            search: {},
            survey: {},
            surveys: [],
            pageNotSurvey: true,
            cnproParentCategories:{},
            sub_categories: {}
        }
    },
    
    methods: {
        setForum(forum){
                localStorage.setItem("cn_f",forum);
                this.$router.push("/forum");
            },
        // Get all surveys
        getSurveys() {
            service.allSurveys(this).then((res) => {
                this.surveys = res.body.data;
            })
        },
        getAllForums() {
            service.getAllForums(this).then(data => {
                if(data.body.status == 200) {
                    this.forums = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        checkCurrentPage(){
            if((this.$route.path != '/cnsurveys')){
                this.pageNotSurvey = true;
            }else{
                this.pageNotSurvey = false;
            }
        },
        /* pre searchers */
        getCnproParentCategories() {
            service.getCnproParentCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.cnproParentCategories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //cnpro sub categories
        getCnproSubCategories(parent){
            service.getCnproCategories(this,parent).then(data => {
                if(data.body.status == 200) {
                    this.sub_categories = data.body.data;
                // document.getElementById("loader").style.visibility = "hidden";
                }
            }).catch((err) => {
                if(err) {
                    //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        //businesses
        getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
                if(data.body.status == 200) {
                    this.sub_categories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                // toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        prep_sub_categories(parent){
            if(parent == "business-search"){
                this.search.type = 'business-search';
                this.getBusinessCategories()
            }
            else{
                this.search.type = 'cnpro-search';
                this.getCnproSubCategories(parent)
            }
        },
        prep_search(keywords){
            this.search.keywords = keywords
            this.search.city = 'Abuja'
        },
        /* pre searchers */
        doSearch(){
            var credentials = {
                search_type: this.search.type,
                search_keywords: this.search.keywords,
                search_city: this.search.city
            }

            let navi = this.$router;

            if(credentials.search_type != null || credentials.search_keywords != null) {
                navi.push(this.search.type+'?context='+this.search.keywords+'&city='+this.search.city);
                
           }else {
                toastr.error('Kindly fill all fields', 'Warning!');
            }

        //     if(credentials.search_type != null || credentials.search_keywords != null) {
        //         if(credentials.search_type == "businesses") {
        //             localStorage.setItem("cityneeds_search_type", this.search.type);
        //             localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
        //             localStorage.setItem("cityneeds_search_city", this.search.city);
        //             navi.push("business-search");
        //         }
        //          else if(credentials.search_type == "cnpros") {
        //             //use local storage for now
        //             localStorage.setItem("cityneeds_search_type", this.search.type);
        //             localStorage.setItem("cityneeds_search_keywords", this.search.keywords);
        //             localStorage.setItem("cityneeds_search_city", this.search.city);
        //             navi.push("cnpro-search");
                   
        //         }
        //    }else {
        //         toastr.error('Kindly fill all fields', 'Warning!');
        //     }
        
        },
    },
    created: function(){
        this.getAllForums();
        this.getSurveys();
        this.checkCurrentPage();
        this.getCnproParentCategories();
    }
}
</script>




// WEBPACK FOOTER //
// HorizontalWidget.vue?50ff2eea